/* XION • animations.js
   Scroll-triggered entrance animations via IntersectionObserver. No libraries.
   Fires once per element. Honors prefers-reduced-motion.
   Safe: never hides full-page content wrappers; on-screen content always reveals. */
(function () {
  'use strict';

  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SUPPORTED = 'IntersectionObserver' in window;
  var OBSERVE_SELECTOR = '.animate-fade-up,.animate-fade-in-left,.animate-fade-in-right,.animate-scale-in,.stagger-container';
  var REVEAL_SELECTOR = '.animate-fade-up,.animate-fade-in-left,.animate-fade-in-right,.animate-scale-in,.stagger-item';

  function onReady(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }

  /* Auto-tag common elements so the theme animates without editing every section file.
     Full-page wrappers (.shopify-section--main-*) are never tagged, so page content is
     never hidden behind an animation that may not trigger on very tall pages. */
  function autoTag() {
    var main = document.getElementById('main') || document.body;
    var hasAnim = /animate-(fade-up|fade-in-left|fade-in-right|scale-in)|stagger-container/;

    main.querySelectorAll('.shopify-section, .video-feature-section, .fade-scroll-section').forEach(function (el) {
      if (/--main-/.test(el.className)) { return; }
      if (hasAnim.test(el.className)) { return; }
      el.classList.add('animate-fade-up');
    });

    main.querySelectorAll('.xfp-cards,.xfp-rev-grid,.xfp-includes-grid,.xfp-addons,.xfp-op-grid,.xm-g3,.xm-g2,.xm-grid,.xm-steps,.xcp-grid,.xpp-grid,.xpa-grid,ul.xm-list').forEach(function (grid) {
      grid.classList.add('stagger-container');
      Array.prototype.forEach.call(grid.children, function (child) { child.classList.add('stagger-item'); });
    });

    main.querySelectorAll('.xfp-stat,.xm-stat,.xr-stat,.feature-icon').forEach(function (el) {
      if (!hasAnim.test(el.className)) { el.classList.add('animate-scale-in'); }
    });
  }

  /* Number count-up removed (V28): figures always render at their real values,
     so visitors and screenshots never catch partial numbers mid-animation.
     Kept as a no-op so any element with data-count simply shows its text. */
  function animateCount() {}

  function reveal(el) {
    el.classList.add('is-visible');
    if (el.classList.contains('stagger-container')) {
      el.querySelectorAll('.stagger-item').forEach(function (it) { it.classList.add('is-visible'); });
    }
    if (el.hasAttribute('data-count')) { animateCount(el); }
  }

  function revealAll() {
    document.querySelectorAll(REVEAL_SELECTOR).forEach(function (el) { el.classList.add('is-visible'); });
    document.querySelectorAll('[data-count]').forEach(animateCount);
  }

  onReady(function () {
    autoTag();

    document.querySelectorAll('.stagger-container').forEach(function (c) {
      var items = c.querySelectorAll('.stagger-item');
      for (var i = 0; i < items.length; i++) { items[i].style.transitionDelay = (i * 0.1) + 's'; }
    });

    if (REDUCE || !SUPPORTED) { revealAll(); return; }

    document.documentElement.classList.add('anim-ready');

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) { return; }
        reveal(e.target);
        io.unobserve(e.target);
      });
    }, { threshold: 0, rootMargin: '0px 0px -10% 0px' });

    document.querySelectorAll(OBSERVE_SELECTOR).forEach(function (el) { io.observe(el); });

    /* Safety net: after load, force-reveal any on-screen element the observer missed,
       so content can never get stuck invisible. Below-fold elements still animate on scroll. */
    window.addEventListener('load', function () {
      setTimeout(function () {
        var vh = window.innerHeight || document.documentElement.clientHeight;
        document.querySelectorAll(REVEAL_SELECTOR).forEach(function (el) {
          if (el.classList.contains('is-visible')) { return; }
          if (el.getBoundingClientRect().top < vh) { el.classList.add('is-visible'); }
        });
      }, 600);
    });
  });
})();
